<div class="sdp-form-control">
	<p *ngFor="let message of messages">{{ message }}</p>
	<!-- <p>{{ "forgotpassword.verify.1" | translate }}</p>
	<p>{{ "forgotpassword.verify.2" | translate }}</p>
	<p>{{ "forgotpassword.verify.3" | translate }}</p> -->
</div>
<div class="sdp-form-buttons-container">
	<button
		color="primary"
		(click)="back()"
		mat-raised-button
	>{{ "registration.signIn.title" | translate }}</button>
</div>